// extracted by mini-css-extract-plugin
module.exports = {"placeHolder":"tagMember_placeHolder__1I0w2","container":"tagMember_container__2zcbu","userContainer":"tagMember_userContainer__11Trr"};